import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './services/GlobalVariables'
import DrawerLayout from 'vue-drawer-layout'
import router from './router'
import store from './store'
import './assets/fonts/icons.js'
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import './registerServiceWorker'

Vue.use(DrawerLayout);
Vue.use(VueGoodTablePlugin);
Vue.component('v-select',vSelect)

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
